import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const textProps = buildProps({
  isTooltip: {
    type: Boolean,
    default: true,
  },
  isCopy: {
    type: Boolean,
    default: true,
  },
  textLine: {
    type: Number,
  },
  width: {
    type: Number,
  },
  popperClass: {
    type: String,
  },
} as const);

export type TextProps = ExtractPropTypes<typeof textProps>;
